import { createSlice } from "@reduxjs/toolkit";
import { API_LOAD_STATUS, PORTAL_KEY as name } from "constants/labels";
import {
  getProfileInfoApi,
  getCurrentBillingApi,
  getEnergyUsageApi,
  postReconnectServiceApi,
  getAccountLookupApi,
  getGrantInfoApi,
  getReportAccountBalanceApi,
  getBillPaymentHistoryApi,
  getReportEnergyUsageApi,
  getManageSeasonApi,
  getEmergencyHoldApi,
  getEmergencyHoldStatusApi,
  getReportSampleFileApi,
  getAgencyListApi,
  postOutstandingGrantReportsApi,
  getOutstandingGrantReportsApi,
  getReportEnergyUsageAnnualApi,
  getReportEnergyUsageMonthlyApi,
  getTooltipMsgsApi,
  getReconnectionRequestReportApi,
  getPledgeAmountReportApi,
  getEmergencyHoldReportApi,
} from "services/energyAssistance/energyAssistance.thunks";
import { initialState } from "container/energyAssistance/store/initialState";

export const energyAssistanceSlice = createSlice({
  name,
  initialState,
  reducers: {
    setProfileInfo: (state, action) => (state.profileInfo = action.payload),
  },
  extraReducers: (builder) => {
    const { PENDING, FULFILLED, REJECTED } = API_LOAD_STATUS;
    const addCaseGroup = (thunk, key) => {
      builder
        .addCase(thunk.pending, (state) => {
          state[key].Load = {
            ...state[key].Load,
            status: PENDING,
          };
          state[key].Succeeded = false;
          state[key].Data = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          const actionPayload = action.payload;
          const Data = actionPayload?.Data;
          const Message = actionPayload?.Message;
          const Succeeded = actionPayload?.Succeeded;

          let message = Message;

          if (key !== "billPaymentPDF" || key !== "currentBillPDF") {
            if (Succeeded) {
              message = Data?.Message || "";
            }
          } else {
            message = Data?.SapErrors[0]?.MessageTxt1 || "";
          }
          state[key].Load = {
            ...state[key].Load,
            status: FULFILLED,
            message,
          };
          state[key].Succeeded = Succeeded ?? false;
          state[key].Data = Data ?? null;
        })
        .addCase(thunk.rejected, (state, action) => {
          const { Message, Errors } = action.payload;
          state[key].Load = {
            ...state[key].Load,
            status: REJECTED,
            message: Message,
            errors: Errors,
          };
          state[key].Succeeded = false;
          state[key].Data = null;
        });
    };

    addCaseGroup(getAccountLookupApi, "accountLookup");
    addCaseGroup(getProfileInfoApi, "profileInfo");
    addCaseGroup(getEnergyUsageApi, "energyUsage");
    addCaseGroup(getCurrentBillingApi, "currentBilling");
    addCaseGroup(getGrantInfoApi, "grantInfo");
    addCaseGroup(getBillPaymentHistoryApi, "billingAndPaymentHistory");
    addCaseGroup(postReconnectServiceApi, "reconnect");
    addCaseGroup(getReportAccountBalanceApi, "accountBalanceReport");
    addCaseGroup(getReportEnergyUsageApi, "energyUsageReport");
    addCaseGroup(getManageSeasonApi, "manageSeason");
    addCaseGroup(getEmergencyHoldApi, "emergencyHold");
    addCaseGroup(getEmergencyHoldStatusApi, "emergencyHoldStatus");
    addCaseGroup(getReportSampleFileApi, "reportSampleFile");
    addCaseGroup(getAgencyListApi, "agencies");
    addCaseGroup(postOutstandingGrantReportsApi, "grantReport");
    addCaseGroup(getOutstandingGrantReportsApi, "grantReport");
    addCaseGroup(getReportEnergyUsageAnnualApi, "energyUsageReport");
    addCaseGroup(getReportEnergyUsageMonthlyApi, "energyUsageReport");
    addCaseGroup(getTooltipMsgsApi, "tooltipMsgs");
    addCaseGroup(getReconnectionRequestReportApi, "reconnectionRequestReport");
    addCaseGroup(getPledgeAmountReportApi, "pledgeAmountReport");
    addCaseGroup(getEmergencyHoldReportApi, "emergencyHoldReport");
  },
});

export const { setProfileInfo } = energyAssistanceSlice.actions;
